import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Pin14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 13.6289C7.41177 13.1651 7.82311 12.7029 8.21065 12.2185C9.78602 10.2493 11.75 7.6643 11.75 5C11.75 2.37665 9.62335 0.25 7 0.25C4.37665 0.25 2.25 2.37665 2.25 5C2.25 7.6643 4.21398 10.2493 5.78935 12.2185C6.17689 12.7029 6.58823 13.1651 7 13.6289ZM3.75 5C3.75 3.20507 5.20507 1.75 7 1.75C8.79493 1.75 10.25 3.20507 10.25 5C10.25 7.31438 8.356 9.63977 7 11.3305C5.64406 9.63968 3.75 7.31442 3.75 5Z'
      fill='currentColor'
    />
  </Svg>
);

Pin14.displayName = 'Pin14';
export default Pin14;
